import { render, staticRenderFns } from "./setUpSweepModal.vue?vue&type=template&id=4afa2206"
import script from "./setUpSweepModal.vue?vue&type=script&lang=js"
export * from "./setUpSweepModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports